// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M23 9V3H1V9L23 9Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M23 11V21L1 21V11H13V16.4971L15.5 14.3338L18 16.4971V11H23Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-cardmembership-filled')
export default class CardmembershipFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'cardmembership-filled',
    }
  }
}
